import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-79">
      <div className="container mx-auto px-4 max-w-5xl text-center" data-id="element-80">
        <div className="text-white font-bold text-xl mb-6 flex items-center justify-center gap-2" data-id="element-81">
          🛡️ MEGA PACK HIGIENE Y SEGURIDAD BLINDADA
        </div>

        <p className="text-sm max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-82">
          Este producto es una herramienta de organización y documentación para
          profesionales de Higiene y Seguridad independientes. No constituye
          asesoramiento legal, contable ni impositivo, ni reemplaza la consulta
          con un profesional matriculado en cada materia.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm mb-8" data-id="element-83">
          <a href="#" className="hover:text-white transition-colors" data-id="element-84">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-85">
            Política de Privacidad
          </a>
          <a href="mailto:soporte@mega-pack-hys.com" className="hover:text-white transition-colors" data-id="element-86">
            Contacto
          </a>
        </div>

        <div className="text-xs text-slate-600" data-id="element-87">
          <p data-id="element-88">
            © 2026 Mega Pack Higiene y Seguridad Blindada — Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}